<template>
  <pbc-overlay ref='modal' @close="onClose" :disable-title="true" @done='onDone'>
    <template #default="{}">
      <div class='pointer-events-auto overflow-hidden flex flex-col'>

        <!--
        <div class="flex-none mx-0 md:mx-64 flex justify-center">
          <pbc-toggle-button v-model='isSticker' class="w-24 text-lg p-2 my-2" mode='outline'>
            <span class="mx-auto">Stickers</span>
          </pbc-toggle-button>
          <pbc-toggle-button v-model='isToy' class="w-24 text-lg p-2 my-2" mode='outline'>
            <span class="mx-auto">Toys</span>
          </pbc-toggle-button>
        </div>
        -->

        <div v-if='isSticker' class="overflow-y-auto grow">
          <view-gfycat-stickers :partutil='partutil' 
                                @select='onSelectAnimation'
            />
          <!--
          <apollo-query :query='getAnimationsQuery'
                        fetch-policy='cache-and-network'
                        :variables='{from:0,size:100}'>
            <template v-slot='{ result: { loading, error, data }, isLoading }'>
              <div v-if='isLoading || loading' class="spinner text-xl mt-8 mb-4" />
                <view-animations v-if='!isLoading && !loading'
                                :animations='(((data||{}).getAnimations)||{}).items||[]' 
                                :partutil='partutil'
                                @select='onSelectAnimation'
                                />
            </template>
          </apollo-query>
          -->
        </div>

        <div v-else-if='isToy' class="overflow-y-auto grow">
          <apollo-query :query='getToysQuery'
                        fetch-policy='cache-and-network'
                        :variables='{from:0,size:100}'>

            <template v-slot='{ result: { loading, error, data }, isLoading }'>
              <div v-if='isLoading || loading' class="spinner text-xl mt-8 mb-4" />
                <div class="font-semibold text-sm text-gray-300">
                  Stickers are animated pieces you can use to add flavour to your creation
                </div>
                <div class="p-2 grid grid-cols-2 gap-3"> 
                  <button v-for='toy in filterStickers((((data||{}).getToys||{}).items||[]))' :key='toy.id' class='pointer-events-auto' @click='onSelect(toy)'>
                    <preview-game class='w-full h-32 pointer-events-none'
                                  :gamedata='makeToy(toy.toy)' />
                    <span class="text-white text-xs font-thin">
                      {{toy.name}}
                    </span>
                  </button>
                </div>

                <div class="font-semibold text-gray-300 text-sm">
                  Toys are interactive stickers that users can interact making your creation truly unique.
                </div>
                <div class='p-2 grid grid-cols-2 gap-3'>
                  <div v-for='toy in filterToys((((data||{}).getToys||{}).items||[]))' 
                          :key='toy.id'
                          class='pointer-events-auto'>
                    <div class="h-24 w-full relative">
                      <preview-game class='w-full h-24'
                                    :enable-interactivity='true'
                                    :timelimit='0'
                                    :gamedata='makeToy(toy.toy)' />
                      <div class='absolute right-0 bottom-0 pointer-events-none'>
                        <gesture-tap :size='32' class='text-white' />
                      </div>
                    </div>
                    <button class='mt-1 w-full outline-button p-2' @click='onSelect(toy)'>
                      <div>
                        <plus-circle />
                      </div>

                      <p class="mx-auto">{{toy.name}}</p>
                    </button>
                  </div>
                </div>
            </template>
          </apollo-query>

        </div>

      </div>
    </template>
  </pbc-overlay>
</template>
<script>
import GestureTap from '@icons/GestureTap.vue';
import PlusCircle from '@icons/PlusCircle.vue';
//import ViewAnimations from '@ui/molecules/ViewAnimations.vue';
import ViewGfycatStickers from '@ui/molecules/ViewGfycatStickers.vue';
import { cloneDeep } from 'lodash';
const PreviewGame  = () => import(/* webpackChunkName: "play" */ '@/ui/organisms/PreviewGame.vue');
import { getAnimationsQuery, getToysQuery } from '@/gql/Queries.js';
import { ApolloQuery } from 'vue-apollo';

export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    },
  },
  data() {
    const previewOptions = {
      forceCanvas: true
    }
    return {
      getToysQuery,
      //getAnimationsQuery,
      previewOptions,
      mode:'sticker'
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onDone() {
      this.$emit('done');
    },
    hasTapController(toy) {
      return JSON.parse(toy.toy).components.filter( ({type}) => {
        return type === 'tapcontroller';
      }).length > 0;
    },
    filterStickers(toys) {
      return toys.filter( (toy) => {
        return toy.public && !this.hasTapController(toy);
      });
    },
    filterToys(toys) {
      return toys.filter( (toy) => {
        return toy.public && this.hasTapController(toy);
      });
    },
    onSelectAnimation(animation) {
      console.log('add animation', animation)
      const layer = {
        id:"toy",
        name:"Toy",
        zindex:2,
        projection:"orthogonal",
        direction:"rightdown"
      }

      const {newChildren, newComponents, newParents, sprite} = this.partutil.addSprite(this.partutil.root, layer);
      console.log('i added a sprite', sprite);
      sprite.anim = true;
      sprite.anims = [{
        frames:JSON.parse(animation.frames),
        loopByDefault: animation.loopByDefault,
        timePerFrame: animation.timePerFrame
      }]
      sprite.atlas = sprite.anims[0].frames[0].atlas;
      sprite.sprite = sprite.anims[0].frames[0].texture;
      sprite.texture = sprite.anims[0].frames[0].texture;
      console.log('have sprite', sprite);

      newChildren.forEach( (child) => {
        child.transform.scale.x = 1.4;
        child.transform.scale.y = 1.4;
      });
      //sprite.anims = JSON.parse(animation.frames);
      //sprite.loopByDefault = animation.loopByDefault;
      //sprite.timePerFrame = animation.timePerFrame;

      this.$emit('add-children', {
        newChildren,
        newParents,
        newComponents
      });

      this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'add',
        extra: {
          type: 'animation'
        }
      });

      this.$emit('done');
    },
    onSelect(toy) {
      console.log('select toy', toy);
      const layer = {
        id:"toy",
        name:"Toy",
        zindex:2,
        projection:"orthogonal",
        direction:"rightdown"
      }
      this.partutil.selectLayer(layer);

      toy = cloneDeep(JSON.parse(toy.toy));

      const {newChildren, newComponents, newParents} = this.partutil.addToy(this.partutil.root, toy, layer);

      this.$emit('add-children', {
        newChildren,
        newParents,
        newComponents
      });

      this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'add',
        extra: {
          type: 'sticker'
        }
      });

      this.$emit('done');

    },
    makeToy(in_toy) {
      const toy = JSON.parse(in_toy);
      toy.layers = {
        default: {
        "id":"default",
        "name":"Foreground",
        "zindex":1,
        "projection":"orthogonal",
        "direction":"rightdown"
        }
      };
      return {
        id:toy.id,
        scenes:[
          toy
        ],
        components:[],
        links:[],
        toybox:[],
        layers:toy.layers
      }
    }
  },
  components: {
    ApolloQuery,
    PreviewGame,
    PlusCircle,
    GestureTap,
    ViewGfycatStickers
    //ViewAnimations
  },
  computed: {
    isSticker: {
      set(nv) {
        this.mode = "sticker"
      },
      get() {
        return this.mode === 'sticker';
      }
    },
    isToy: {
      set(nv) {
        this.mode = "toy"
      },
      get() {
        return this.mode === 'toy';
      }
    }

  }
}
</script>
